import React from 'react'
import { Link } from 'react-router-dom'
import "./NotFound.scss"

function NotFound() {
  return (
    <div className="not-found-container">
    <div className="not-found-content">
        <img src="/notfound.png" alt="not found" />
      <h1 className="not-found-title">404</h1>
      <p className="not-found-message">Oops! Our dog ate this page.</p>
      <Link to="/" className="not-found-btn">
        Go Back to Home
      </Link>
    </div>
  </div>
  )
}

export default NotFound